module.exports = __webpack_public_path__ + "img/tag-about.f0dac0d8.svg";